/*
 * Copyright (C) 2025 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MediaUidService {
  private mediaUidSubject = new BehaviorSubject<string | null>(null);
  mediaUid$: Observable<string | null> = this.mediaUidSubject.asObservable();

  setMediaUid(mediaUid: string | null): void {
    this.mediaUidSubject.next(mediaUid);
  }

  getMediaUid(): string | null {
    return this.mediaUidSubject.value;
  }
}
